import React from 'react'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setCaseManagersList,
  setCaseManagersListLoader,
  setCaseManagersModalLoader
} from 'src/store/modules/admin'
import { getCaseManagers as getCompanyCaseManagers } from 'src/store/modules/company'

import {
  COMPANY_CASE_MANAGERS,
  DETAILED_QUERY_PARAM,
  REASSIGN_CASE_MANAGER_PATIENTS,
  UPDATE_CASE_MANAGER,
  UPDATE_CASE_MANAGER_STATUS
} from 'src/constants'
import { showErrorModal } from 'src/services/dialogs'

export const getCaseManagers =
  (query = {}) =>
  async (dispatch) => {
    dispatch(setCaseManagersListLoader(true))

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_CASE_MANAGERS,
          query: {
            sort: 'fullName:asc',
            ...query
          }
        }
      })

      dispatch(setCaseManagersList(items))
      return meta
    } catch (err) {
      catchError(err)
    } finally {
      dispatch(setCaseManagersListLoader(false))
    }
  }

export const createCaseManager = (payload, query) => async (dispatch) => {
  dispatch(setCaseManagersModalLoader(true))
  try {
    await httpClient.request({
      method: 'post',
      url: {
        pathname: COMPANY_CASE_MANAGERS
      },
      payload
    })
    await dispatch(getCaseManagers(query))
    dispatch(
      getCompanyCaseManagers({
        query: {
          ...DETAILED_QUERY_PARAM,
          sort: 'fullName:asc',
          'per-page': 10000
        }
      })
    )
    return false
  } catch (err) {
    const { errors, message } = err

    if (message && !errors) {
      catchError(err)
    }

    if (errors) {
      const content = (
        <div>
          {Object.keys(errors).map((key) => (
            <span style={{ marginBottom: '10px' }} key={key}>
              {errors[key][0]}
              <br />
            </span>
          ))}
        </div>
      )

      showErrorModal({
        title: 'Validation Error',
        content
      })
    }

    return err
  } finally {
    dispatch(setCaseManagersModalLoader(false))
  }
}

export const updateCaseManager = (payload, uuid, query) => async (dispatch) => {
  dispatch(setCaseManagersModalLoader(true))
  try {
    await httpClient.request({
      method: 'patch',
      url: {
        pathname: UPDATE_CASE_MANAGER,
        params: {
          uuid
        }
      },
      payload
    })
    await dispatch(getCaseManagers(query))
    dispatch(
      getCompanyCaseManagers({
        query: {
          ...DETAILED_QUERY_PARAM,
          sort: 'fullName:asc',
          'per-page': 10000
        }
      })
    )
    return false
  } catch (err) {
    const { errors, message } = err

    if (message) {
      catchError(err)
    }

    if (errors) {
      const content = (
        <div>
          {Object.keys(errors).map((key) => (
            <span style={{ marginBottom: '10px' }} key={key}>
              {errors[key][0]}
              <br />
            </span>
          ))}
        </div>
      )

      showErrorModal({
        title: 'Validation Error',
        content
      })
    }
    return err
  } finally {
    dispatch(setCaseManagersModalLoader(false))
  }
}

export const updateCaseManagerStatus =
  (payload, uuid, query) => async (dispatch) => {
    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: UPDATE_CASE_MANAGER_STATUS,
          params: {
            uuid
          }
        },
        payload
      })
      await dispatch(getCaseManagers(query))
      dispatch(
        getCompanyCaseManagers({
          query: {
            ...DETAILED_QUERY_PARAM,
            sort: 'fullName:asc',
            'per-page': 10000
          }
        })
      )

      return true
    } catch (err) {
      if (!err?.isHasAssignedPatients) {
        catchError(err)
      }

      return err
    }
  }

export const reassigCaseManagerPatients =
  (config = {}, query = {}) =>
  async (dispatch) => {
    const { payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: REASSIGN_CASE_MANAGER_PATIENTS
        },
        payload
      })

      await dispatch(getCaseManagers(query))
      dispatch(
        getCompanyCaseManagers({
          query: {
            ...DETAILED_QUERY_PARAM,
            sort: 'fullName:asc',
            'per-page': 10000
          }
        })
      )

      return true
    } catch (err) {
      catchError(err)

      return err
    }
  }

export const getAvaliableCaseManagers =
  (config = {}) =>
  async () => {
    const { query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_CASE_MANAGERS,
          query: {
            sort: 'fullName:asc',
            ...query
          }
        }
      })

      return items
    } catch (err) {
      catchError(err)

      return []
    }
  }
